import React, { useEffect, useState } from 'react';
import { Result, Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supabase } from './supabaseClient';

const PaymentSuccess = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [quotas, setQuotas] = useState(null);

    useEffect(() => {
        fetchUserQuotas();
    }, []);

    const fetchUserQuotas = async () => {
        try {
            const { data: { user } } = await supabase.auth.getUser();
            if (!user) throw new Error('User not found.');

            const { data, error } = await supabase
                .from('user_quotas')
                .select('transcription_quota')
                .eq('user_id', user.id)
                .single();

            if (error) throw error;
            setQuotas(data);
        } catch (error) {
            console.error('Error fetching quota information:', error.message);
        }
    };

    return (
        <Result
            status="success"
            title={t("Payment completed successfully!")}
            subTitle={
                quotas
                    ? t("Current remaining quota: Transcription {transcription}",
                        { transcription: quotas.transcription_quota })
                    : t("Loading quota information...")
            }
            extra={[
                <Button type="primary" key="console" onClick={() => navigate('/')}>
                    {t("Go to Main Page")}
                </Button>,
                <Link to="/settings" key="settings">
                    <Button>{t("Go to Settings")}</Button>
                </Link>,
            ]}
        />
    );
};

export default PaymentSuccess;